import { Typography } from '@mui/material';
import { useBulkUploadSearchStore } from 'src/zustand/useAILabelingStore';

const FormBulkUploadFooter = () => {
  const { dispatch } = useBulkUploadSearchStore();

  return (
    <Typography
      component={'div'}
      onClick={() => dispatch(true, 'visibleHistoryBulkUpload')}
      mt={2}
      textAlign={'center'}
      color={'text.secondary'}
      variant="body2"
    >
      Previous results?{' '}
      <Typography
        component={'span'}
        sx={{ textDecoration: 'underline', cursor: 'pointer' }}
        display={'inline'}
        variant="body2"
        color={'secondary'}
      >
        View File Upload History
      </Typography>
    </Typography>
  );
};

export default FormBulkUploadFooter;
